import { useState, useEffect } from 'react';
import FiberCompanyApi from '../../../../../../API/FiberCompanyApi';
import StringIntReq from '../../../../../../Requests/StringIntReq';

const useSalesRepStats = (salesRepId) => {
  const [stats, setStats] = useState({
    rank: 0,
    totalSales: 0,
    totalInstalls: 0,
    totalReviews: 0,
    avgRating: 0,
  });
  const [loadingStats, setLoadingStats] = useState(false);

  useEffect(() => {
    const fetchStats = async () => {
      if (!salesRepId) return;
      setLoadingStats(true);
      const req = new StringIntReq();
      req.int = salesRepId;
      const res = await FiberCompanyApi.GetRepStats(req);
      if (res?.status?.success) {
        setStats({
          rank: res.data.rank,
          totalSales: res.data.totalSales,
          totalInstalls: res.data.totalInstalls,
          totalReviews: res.data.totalReviews,
          avgRating: res.data.avgRating,
        });
      } else {
        setStats({
          rank: 0,
          totalSales: 0,
          totalInstalls: 0,
          totalReviews: 0,
          avgRating: 0,
        });
      }
      setLoadingStats(false);
    };

    fetchStats();
  }, [salesRepId]);

  return { stats, loadingStats };
};

export default useSalesRepStats;
